<template>
 <header class="main-header">
    <!-- Logo -->
    <a href="#" class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini"><img class="img-circle" src="/static/img/nivi-logo.png" width="50px"></span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg"><img class="img-circle" src="/static/img/nivi-logo.png" width="80px"></span>
    </a>
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <a href="#" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
        <!-- Menu logout -->
        <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <!-- Control Sidebar Toggle Button -->
          <li>
            <a href="javascript::void(0)" @click="exitApp" data-toggle="control-sidebar">
              <i class="fa fa-sign-out"></i>
              <span>Logout</span></a>
          </li>
        </ul>
      </div>  
    </nav>
  </header>
</template>

<script>
import { logout } from '../utils/auth';

export default {
  name: 'app-header',
  methods: {
    exitApp() {
      logout();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Header.vue